import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Account/AddBonusCard/addBonusCard.container"
    ).then((module) => ({ default: module.AddBonusCard }))
);
